import ScrollHint from 'scroll-hint';
new ScrollHint('.table',{
	i18n: {
		scrollable: 'スクロールできます'
	},
	remainingTime: -1,
});